import { defineStore } from "pinia";
import { Team } from "@/common/models/team";
import { fetchTeams } from "@/common/services/teams.service";
import { useErrorStore } from "@/common/store/error.store";
import { upsertEntities } from "@/common/store/utils";

interface TeamsState {
  ids: string[];
  entities: { [id: string]: Team };
}

export const useTeamsStore = defineStore("teams", {
  state: (): TeamsState => ({
    ids: [],
    entities: {},
  }),

  getters: {
    all(): Team[] {
      return this.ids.map((id) => this.entities[id]);
    },
  },

  actions: {
    async fetchTeams(): Promise<void> {
      try {
        const teams = await fetchTeams();
        this.fetchTeamsSuccess(teams);
      } catch (error) {
        this.fetchTeamsError(error);
      }
    },

    fetchTeamsSuccess(teams: Team[]): void {
      upsertEntities(teams, this);
    },

    fetchTeamsError(err: any): void {
      const errorStore = useErrorStore();
      errorStore.throwError(`fetchTeamsError: ${err.toString()}`);
    },
  },
});
